/* unplugin-vue-components disabled */import { render } from "./status.vue?vue&type=template&id=73e38986&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"

import "./status.vue?vue&type=style&index=0&id=73e38986&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e38986"]])

export default __exports__